<script setup lang="ts">
import {computed} from "vue";

const props = withDefaults(defineProps<{ active?: boolean; color?: string }>(), {
  active: false,
  color: "primary",
});

const baseLight = computed(() => props.color === "primary" ? "var(--nama-primary-light)" : props.color);
const baseDark = computed(() => props.color === "primary" ? "var(--nama-primary-dark)" : props.color);
</script>

<template>
  <div class="animated-bell tw-relative" :class="{ 'is-active': active }">
    <slot/>
  </div>
</template>

<style scoped lang="scss">
.animated-bell {
  --bell-color: v-bind(baseLight);
  --bell-ring-bg: color-mix(in srgb, var(--bell-color) 8%, white);
  --bell-ring-border: color-mix(in srgb, var(--bell-color) 28%, white);
}

.tw-dark {
  .animated-bell {
    --bell-color: v-bind(baseDark);
    --bell-ring-bg: color-mix(in srgb, var(--bell-color) 18%, transparent);
    --bell-ring-border: color-mix(in srgb, var(--bell-color) 40%, transparent);
  }
}

.animated-bell.is-active::before {
  content: "";
  position: absolute;
  inset: -7px;
  border-radius: 9px;
  background: var(--bell-ring-bg);
  border: 1px solid var(--bell-ring-border);
  animation: bellPulse 2.4s ease-out infinite;
}

@keyframes bellPulse {
  0% {
    box-shadow: 0 0 0 0 color-mix(in srgb, var(--bell-color) 45%, transparent);
  }
  70% {
    box-shadow: 0 0 0 8px transparent;
  }
  100% {
    box-shadow: 0 0 0 0 transparent;
  }
}
</style>
